import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHiveComponent } from './simple-icons-hive.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHiveComponent ],
    exports:      [ SimpleIconsHiveComponent ],
    bootstrap:    []
})
export class SimpleIconsHiveModule {}
